import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement> & { color?: string }) {
  const { height = 24, width = 24, color = "#72808F" } = props
  return (
    <svg height={height}
      width={width}
      {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.66663 12.4305V5.36943C2.66663 3.46675 2.66663 2.51542 3.25241 1.92434C3.8382 1.33325 4.78101 1.33325 6.66663 1.33325H9.33329C11.2189 1.33325 12.1617 1.33325 12.7475 1.92434C13.3333 2.51542 13.3333 3.46675 13.3333 5.36943V12.4305C13.3333 13.4383 13.3333 13.9421 13.0253 14.1405C12.522 14.4647 11.744 13.7849 11.3527 13.5381C11.0294 13.3342 10.8678 13.2323 10.6883 13.2264C10.4944 13.22 10.3299 13.3178 9.98056 13.5381L8.70663 14.3415C8.36296 14.5582 8.19116 14.6666 7.99996 14.6666C7.80876 14.6666 7.63696 14.5582 7.29329 14.3415L6.01938 13.5381C5.69606 13.3342 5.5344 13.2323 5.35498 13.2264C5.16111 13.22 4.99658 13.3178 4.64721 13.5381C4.25593 13.7849 3.47787 14.4647 2.97459 14.1405C2.66663 13.9421 2.66663 13.4383 2.66663 12.4305Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.33337 7.33325H5.33337" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.33337 4.66675H5.33337" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default SvgComponent
